import React, { useState } from "react";
import { MdOutlineBookmarkAdd, MdMoreHoriz } from "react-icons/md";
import { Link } from "react-router-dom";

export default function ReadingListItem({ item, setSavedToList, savedToList }) {

  const removeBookMarkHander = (id) => {
    let newRem = savedToList.filter((item) => {
      return item.id !== id;
    });
    setSavedToList(newRem);
  };
  return (
    <div className="reading-item">
      <li className="comment">
        <div className="com-name">
          <div className="name-avatar">
            <img src={item.avatar} alt="img" />
            <h5>{item.name}</h5>
            <p>{item.data}</p>
          </div>
          <div className="desc">
            <Link to={`../bosh-sahifa/${item.id}`}>
              <h3>{item.title}</h3>
              <p>{item.decs}</p>
            </Link>

            <div className="underdoge">
              <div className="first-btns">
                <button className="btn-active">Self inprovement</button>
                <button>{item.read}</button>
                <button>Popular in medium</button>
              </div>

              <div className="book-div">
                <button
                  className="bookmark"
                  onClick={() => removeBookMarkHander(item.id)}
                >
                  <MdOutlineBookmarkAdd className="green-one" />
                </button>
                <button>
                  <MdMoreHoriz />
                </button>
                <div className="btn-small-modal">
                  <div className="check-flex">
                    <input id="check" type="checkbox" />
                    <label className="p">Reading List</label>
                  </div>
                  <button className="create-list">Create new List</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="right-img">
          <img src={item.img} alt="img" />
        </div>
      </li>
    </div>
  );
}
